<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Robert Thornton was born in Dublin in 1944 and grew up and went to school there until the age of 15. He moved to Kent, England, in 1959, where he continued his education part-time between different career choices, including engineering apprenticeship, washing machine salesman, debt collector, military (three years) and eventually, schoolteacher and headmaster. He lives in Somerset with his wife, Veronica.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?db70d8e0